import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { GCard } from "~/components/GCard.jsx";
import { GGrid } from "~/components/GGrid.jsx";
import { MainLayout } from "~/components/layout/layout.jsx";
import { usePermission } from "~/compositions/state.js";
import { clubHasFlight } from "~/featureMatrix.jsx";
import { $t } from "~/i18n.js";
import "./dashboard.css";
import "./grid.css";
import { AanmeldlijstWidget } from "./widgets/AanmeldlijstWidget.jsx";
import { CalendarWidget } from "./widgets/CalendarWidget.jsx";
import { DutiesWidget } from "./widgets/DutiesWidget.jsx";
import { EditHomePage } from "./widgets/EditHomePage.jsx";
import { NewsWidget } from "./widgets/NewsWidget.jsx";
import { RecencyWidget } from "./widgets/RecencyWidget.jsx";
import { useClub } from "~/components/club/ClubContext.jsx";

function compileTemplate(template, data = {}) {
  if (!template) return "";
  return template.replace(/\{\{(\w.+)\}\}/g, (_, key) => data[key] || "");
}

export const Dashboard = () => {
  const persist = useSelector((state) => state.persist);
  const { club } = persist;

  const [wijzigHomePage, showWijzigHomePage] = useState(false);

  const { isAssociation } = useClub();

  const { can } = usePermission();

  const hasFlights = clubHasFlight();
  const canAanmelden =
    persist?.profile?.zichzelf_aanmelden ||
    persist?.profile?.iedereen_aanmelden;

  const homepageMessage = compileTemplate(club.homepage_message, {
    "club.name": club.name,
    "user.uuid": persist.profile?.uuid || "-missing-uuid-",
    "user.id": persist.profile?.id || "-missing-id-",
    "user.memberId": persist.profile?.lid_nummer || "-missing-member-id-",
    "user.name": persist.profile?.name || "-missing-name-",
    "user.email": persist.profile?.email || "-missing-email-",
  });

  return (
    <MainLayout>
      {(club.homepage_message?.length > 6 || can("wijzig_news")) && (
        <GCard style={{ width: "100%", marginBottom: 12 }}>
          {can("wijzig_news") && (
            <div>
              {!wijzigHomePage && (
                <Button
                  type="link"
                  onClick={(e) => showWijzigHomePage(true)}
                  icon={<EditOutlined />}
                >
                  <span>{$t("Wijzig")}</span>
                </Button>
              )}

              {wijzigHomePage && (
                <Button
                  type="link"
                  onClick={(e) => showWijzigHomePage(false)}
                  icon={<CloseOutlined />}
                >
                  <span>{$t("Annuleer")}</span>
                </Button>
              )}
            </div>
          )}

          {!wijzigHomePage && (
            <>
              <div
                className="markdown"
                dangerouslySetInnerHTML={{ __html: homepageMessage }}
              />
            </>
          )}

          {wijzigHomePage && (
            <EditHomePage
              onComplete={() => showWijzigHomePage(false)}
              visible={wijzigHomePage}
              homepage_message={club.homepage_message}
            />
          )}
        </GCard>
      )}

      {!isAssociation && (
        <GGrid>
          {hasFlights && <CalendarWidget />}

          {canAanmelden && <AanmeldlijstWidget />}

          {canAanmelden && <DutiesWidget />}

          {hasFlights && <RecencyWidget />}

          <NewsWidget />
        </GGrid>
      )}
    </MainLayout>
  );
};
